import React from "react";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import MCSSpace from "components/MCSSpace";
import Typography from "@visa/vds/typography";
import PagePic from '../../_imgs/illustrations/scene/illustration-scene-confused-color.svg';

function ErrorPage(props) {
    return (
        <Grid>
            <MCSSpace height="50px" />
            <Typography style={{ textAlign: "center", margin: "auto" }} tag="h1">Error</Typography>
            <MCSSpace />
            <img style={{ width: "235px", margin: "auto" }} src={PagePic} />
            <MCSSpace />
            <Row>
                <Col textAlign={"center"}>
                    <Typography tag="h4">{props.text}</Typography>
                    <Typography tag="h4">There has been an error processing your request. Please try again later.</Typography>
                </Col>
            </Row>
        </Grid>
    );
}

export default ErrorPage;